import React from "react";
import { GetAppText } from "../../utils";
import logo from "../../assets/images/footerLogo.png";
import facebook from "../../assets/svgs/facebook.svg";
import linkdin from "../../assets/svgs/linkdin.svg";
import tweeter from "../../assets/svgs/tweeter.svg";
import insta from "../../assets/svgs/instagram.svg";
import FooterLogo from "../../assets/images/Footer_White.png";
import { ReactComponent as SunniLogo } from "../../assets/svgs/new_SWD_footer.svg";
import { ReactComponent as IOS } from "../../assets/svgs/apple.svg";
import { ReactComponent as Android } from "../../assets/svgs/android.svg";
import { ReactComponent as Gallery } from "../../assets/svgs/gallery.svg";
import { ReactComponent as Logo } from "../../assets/svgs/logoNew.svg";
import { useSelector } from "react-redux";
import { SeparatorComponent } from "./Separator";
import { NavLink } from "react-router-dom";

function Footer() {
  const settingData = useSelector((state) => state?.setting?.value);

  const InstaInfo = settingData?.data?.find(
    item => item.name === 'INSTAGRAM',
  );

  const FacebookInfo = settingData?.data?.find(
    item => item.name === 'FACEBOOK',
  );

  const websiteInfo = settingData?.data?.find(
    item => item.name === 'WEBSITE',
  );

  const twitterInfo = settingData?.data?.find(
    item => item.name === 'TWITTER',
  );


  const IosInfo = settingData?.data?.find(
    item => item.name === 'IOS_STORE_LINK',
  );

  const androidInfo = settingData?.data?.find(
    item => item.name === 'ANDROID_STORE_LINK',
  );





  const img = [
    { id: 1, name: insta,tooltip:"Instagram",link:InstaInfo?.value },
    { id: 2, name: tweeter ,tooltip:"X",link:twitterInfo?.value},
    { id: 3, name: linkdin ,tooltip:"Linkdin",link:websiteInfo?.value},
    { id: 4, name: facebook,tooltip:"Facebook",link:FacebookInfo?.value },
  ];


  const language = useSelector((state) => state.language.value);

  const app = [
    // { id: 1, name: "App Gallery", img: <Gallery />,link:androidInfo?.value },
    { id: 2, name: "Android", img: <Android /> ,link:androidInfo?.value},
    { id: 3, name: "IOS", img: <IOS /> , link :IosInfo?.value},
  ];

const handleClick=(item)=>{
  window.open(item?.link, "_blank")
}
const handleStore=(item)=>{
  window.open(item?.link, "_blank")
}
  return (
    <footer className="bg-secondary_green shadow dark:bg-gray-900">
      <div className="site-container sm:pt-16 py-10 md:pb-16">
        <div
          className={`sm:flex  ${
            language === "_ar" ? "flex-row-reverse" : ""
          }   sm:justify-between`}
        >
          <div
            className={`sm:space-y-6  space-y-3 flex flex-col ${
              language === "_ar" ? "items-end" : "items-start"
            }`}
          >
          <NavLink to={"/"} className="inline-block w-fit  shrink-0 overflow-hidden">
            <div className="w-[112px] h-[71px] flex items-center overflow-hidden">
              <SunniLogo className="w-full h-full" />
            </div>
          </NavLink>
            <div className={`text-lightTextColor ${
                language === "_ar" ? "flex-row-reverse text-right" : ""
              } flex  lg:text-F16 text-F13`}>
              {GetAppText("official_donation_portal")}
            </div>
          </div>

          <div className="space-y-2.5 sm:pt-0 pt-5   flex-col md:block hidden items-end h-full ">
            <div
              className={`text-white flex  ${
                language === "_ar" ? "flex-row-reverse " : ""
              }  lg:text-F16 text-F14`}
            >
              {GetAppText("download_app")}
            </div>
            <div className={`flex  ${
                language === "_ar" ? "justify-end sm:justify-start" : ""
              } `}>
              <div className={`flex ${
                language === "_ar" ? "justify-end sm:justify-start" : ""
              }  flex-wrap gap-3`}>
                {app &&
                  app?.map((item) => (
                    <div
                    onClick={()=>{handleStore(item)}}
                      key={item?.id}
                      className="flex items-center cursor-pointer space-x-3 lg:text-F16 text-F13 text-white px-4 py-1.5 border-white rounded-md border-2 "
                    >
                      <div>{item.img}</div>
                      <div>{item.name}</div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
        <div className={`flex md:flex-row   ${
                language === "_ar" ? "items-end" : "items-start"
              } 
              flex-col-reverse md:justify-between  
        md:items-center md:space-y-0 space-y-6 space-y-reverse pt-7`}>
          <ul className={`flex  ${
                language === "_ar" ? "justify-end md:justify-start" : ""
              } sm:gap-8 gap-5 md:flex-wrap md:items-center w-full  
          lg:text-F16 text-F14 font-normal text-white md:mb-0 mb-2 dark:text-gray-400`}>
          <NavLink to={"/privacy-policy"}>
          <li>
              <div  className="hover:underline">
                {GetAppText("privacy_policy")}
              </div>
            </li>
            </NavLink>
            <NavLink to={"/terms-condition"}>
            <li>
              <div  className="hover:underline ">
                {GetAppText("terms_use")}
              </div>
            </li>
            </NavLink>
            <NavLink to={"/about-us"}>
            <li>
              <div  className="hover:underline ">
                {GetAppText("about_us")}
              </div>
            </li>
            </NavLink>
            <NavLink to={"/contact-us"}>
            <li>
              <div  className="hover:underline ">
                {GetAppText("contact_us")}
              </div>
            </li>
            </NavLink>
          </ul>
          <div className="space-y-2.5    flex-col md:hidden items-end h-full ">
            <div
              className={`text-white flex  ${
                language === "_ar" ? "flex-row-reverse " : ""
              }  lg:text-F16 text-F14`}
            >
              {GetAppText("download_app")}
            </div>
            <div className={`flex  ${
                language === "_ar" ? "justify-end sm:justify-start" : ""
              } `}>
              <div className={`flex ${
                language === "_ar" ? "justify-end sm:justify-start" : ""
              }  flex-wrap gap-3`}>
                {app &&
                  app?.map((item) => (
                    <div
                    onClick={()=>{handleStore(item)}}
                      key={item?.id}
                      className="flex items-center cursor-pointer space-x-3 lg:text-F16 text-F13 text-white px-4 py-1.5 border-white rounded-md border-2 "
                    >
                      <div>{item.img}</div>
                      <div>{item.name}</div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <ul
            className={`flex flex-wrap  sm:items-center   lg:text-F16 text-F14  ${
              language === "_ar" ? "flex-row-reverse space-x-reverse" : "md:justify-end"
            }   font-normal text-white sm:mb-0 w-full sm:gap-6 gap-5 dark:text-gray-400`}
          >
                  <NavLink to={"/"}>
            <li>
              <div  className="hover:underline  ">
                {GetAppText("home")}
              </div>
            </li>
            </NavLink>
            <NavLink to={"/donation-projects"}>
            <li>
              <div  className="hover:underline ">
                {GetAppText("donation")}
              </div>
            </li>
            </NavLink>
            <NavLink to={"/technical-support"}>
            <li>
              <div  className="hover:underline ">
                {GetAppText("technical_support")}
              </div>
            </li>
            </NavLink>
            {/* <NavLink to={"/donars-bag"}>
            <li>
              <div  className="hover:underline ">
                {GetAppText("donation_basket")}
              </div>
            </li>
            </NavLink> */}
            {/* <NavLink to={"/profile"}>
            <li>
              <a  className="hover:underline ">
                {GetAppText("my_account")}
              </a>
            </li>
            </NavLink> */}
          </ul>
        </div>
     <SeparatorComponent />

        <div className={`flex md:flex-row flex-col flex-wrap ${
              language === "_ar" ? " items-end " : "flex-row-reverse items-start "
            } sm:gap-0 gap-4 md:justify-between md:items-center`}>
          <div className="flex lg:gap-6 gap-4">
            {/* {img &&
              img?.map((item) => (
                <img
                title={item?.tooltip}
                  key={item?.id}
                  src={item.name}
                  className="lg:h-6 lg:w-6 h-5 w-5 cursor-pointer"
                  alt="Logo"
                  onClick={()=>{handleClick(item)}}
                />
              ))} */}
          </div>

          <div
            className={`sm:text-center  ${
              language === "_ar" ? "" : "flex-row-reverse space-x-reverse"
            } text-lightTextColor flex space-x-1 lg:text-F16 text-F13 dark:text-gray-400`}
          >
            <div>{GetAppText("all_rights")} </div>
            <span
              className={`flex ${language === "_ar" ? "" : "flex-row-reverse"}`}
            >
              <div>{new Date().getFullYear()}</div> <div>©</div>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
